import { Box, IconButton, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import { useRecoilState } from "recoil";
import { DeleteIcon, SettingsIcon } from "../../icons";
import { selectedReportListState } from "../../recoil";
import GridSizeMenu from "./GridSizeMenu";

interface ReportCardProps {
  contentId: string;
  title?: string;
  onGridSizeChange: (id: string, size: 4 | 6 | 8 | 12) => void;
  gridSizeMenuExtra?: ReactNode;
  belowHeader?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

// 리포트 상세의 모든 카드가 공유하는 껍데기: hover 시 나타나는 설정/삭제 버튼, 그리드 크기 메뉴, 삭제 처리.
export default function ReportCard({
  contentId,
  title,
  onGridSizeChange,
  gridSizeMenuExtra,
  belowHeader,
  actions,
  children,
}: ReportCardProps) {
  const [, setSelectedReportList] = useRecoilState(selectedReportListState);
  const [isHovered, setIsHovered] = useState(false);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState<null | HTMLElement>(null);

  const handleGridSizeChange = (size: 4 | 6 | 8 | 12) => onGridSizeChange(contentId, size);
  const handleRemove = () => setSelectedReportList((prev) => prev.filter((item) => item.id !== contentId));

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        padding: 1,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box sx={{ display: "flex", gap: 1, justifyContent: "space-between", alignItems: "center" }}>
        {title && (
          <Typography color="var(--text-secondary-color)" variant="h6" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
        )}
        <Box sx={{ display: "flex", gap: 1, opacity: isHovered ? 1 : 0, transition: "opacity 0.2s" }}>
          <IconButton
            onClick={(e) => setSettingsAnchorEl(e.currentTarget)}
            sx={{ color: "var(--icon-color)" }}
          >
            <SettingsIcon />
          </IconButton>
          {actions}
          <IconButton onClick={handleRemove} sx={{ color: "var(--icon-color)" }}>
            <DeleteIcon />
          </IconButton>
        </Box>
      </Box>
      {belowHeader}
      <GridSizeMenu
        anchorEl={settingsAnchorEl}
        onClose={() => setSettingsAnchorEl(null)}
        onGridSizeChange={handleGridSizeChange}
      >
        {gridSizeMenuExtra}
      </GridSizeMenu>
      {children}
    </Box>
  );
}
